import type { CustomizeQuoteState } from '../views/customize-quote/types';

const mergeGlobalValuesIntoState = <T extends CustomizeQuoteState>(data: T) => {
  return {
    ...data,
    global: data.raterX.global,
  };
};

export default mergeGlobalValuesIntoState;
